import type { SignupErrorCode } from '@teo/backend';

export type SignupErrorInfo = {
  message: string;
  errorCode?: string;
  signupErrorCode?: SignupErrorCode;
};

export type SignupErrorPresentation = {
  emailError?: string;
  formError?: string;
  inviteCodeError?: string;
};

export function getSignupErrorCode(data: unknown): SignupErrorCode | undefined {
  return (data as { signupErrorCode?: SignupErrorCode } | undefined)?.signupErrorCode;
}

export function getSignupErrorPresentation(error: SignupErrorInfo): SignupErrorPresentation {
  if (error.errorCode === 'UNAUTHORIZED') {
    return {
      formError: 'Invalid email or password. Please check your credentials.',
    };
  }

  switch (error.signupErrorCode) {
    case 'signup_conflict':
      return {
        formError:
          error.message ||
          'This signup cannot be completed with this email. If you already have an account, try logging in or contact support for help.',
      };
    case 'active_account_exists':
      return {
        emailError: error.message || 'An account with this email already exists.',
      };
    case 'soft_deleted_account_exists':
      return {
        formError: error.message || 'This account cannot complete signup.',
      };
    case 'invite_code_invalid':
      return {
        formError: error.message || 'Please ensure you have a valid invite code',
        inviteCodeError: 'Please ensure you have a valid invite code',
      };
    default:
      return {
        formError: error.message || 'Signup failed. Please try again.',
      };
  }
}

export type { SignupErrorCode };
